var array_fields = ['poste','candidatNom','candidatPrenom','candidatTel','candidatEmail'];

$(function() {

    $("#poste,#candidatNom,#candidatPrenom,#candidatTel,#candidatEmail").on("blur", function() {
        if ($(this).val()=='') {
            $(this).addClass('inputErr');
        } else {
            if($(this).attr('id')=='candidatEmail') {
                var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                var mail_value = $(this).val();
                if(mail_value.match(mailformat))
                {
                    $(this).removeClass('inputErr');
                } else {
                    $(this).addClass('inputErr');
                }
            } else if ($(this).attr('id')=='candidatTel') {
                if( $("#candidatTel").intlTelInput("isValidNumber") == false ){
                    $(this).addClass('inputErr');
                } else {
                    $(this).removeClass('inputErr');
                }
            } else {
                $(this).removeClass('inputErr');
            }
        }
    });

    var bloc_annonce_trigger = $('.offre-module .annonce h3');
    var bloc_annonce_content = $('.description');

    bloc_annonce_trigger.on('click touch', function(){
        if(!$(this).hasClass('actif')){
            $(this).addClass('actif');
            if($('body').hasClass('mobile')){
                $(this).css("padding-bottom", "3.125rem");
            } else {
                $(this).css("padding-bottom", "50px");
            }
            $(this).next(bloc_annonce_content).slideDown();
        } else {
            $(this).next(bloc_annonce_content).slideUp();
            $(this).removeClass('actif');
            if($('body').hasClass('mobile')){
                $(this).css("padding-bottom", "2.4375rem");
            } else {
                $(this).css("padding-bottom", "39px");
            }
        }

        bloc_annonce_trigger.not(this).each(function(){
            $(this).next(bloc_annonce_content).slideUp();
            $(this).removeClass('actif');
            if($('body').hasClass('mobile')){
                $(this).css("padding-bottom", "2.4375rem");
            } else {
                $(this).css("padding-bottom", "39px");
            }
        });
    });

    $("#cv").change(function(e) {
        var filename = $("#cv")[0].files[0].name;
        var phrase = translate("file_error");
        var textOR = translate("or");
        var ext = filename
            .split(".")
            .pop()
            .toLowerCase();

        if ($.inArray(ext, ["pdf", "jpg"]) == -1) {
            $(".bloc_cv .upload").addClass("inputErr");
            $(".bloc_cv .file_msg").text(phrase + "JPG " + textOR + " PDF");
            $(this).val("");
            return false;
        } else {
            $(".bloc_cv .upload").removeClass("inputErr");
            $(".bloc_cv .file_msg").text($("#cv")[0].files[0].name);
            if($('body').hasClass('mobile')){
                $(".bloc_cv .file_msg").show();
            }
        }
    });

    $("#motivation_letter").change(function(e) {
        var filename = $("#motivation_letter")[0].files[0].name;
        var phrase = Translator.translate("file_error");
        var ext = filename
            .split(".")
            .pop()
            .toLowerCase();

        if ($.inArray(ext, ["pdf"]) == -1) {
            $(".bloc_motivation .upload").addClass("inputErr");
            $(".bloc_motivation .file_msg").text(phrase + "PDF");
            $(this).val("");
            return false;
        } else {
            $(".bloc_motivation .upload").removeClass("inputErr");
            $(".bloc_motivation .file_msg").text($("#motivation_letter")[0].files[0].name);
            if($('body').hasClass('mobile')){
                $(".bloc_cv .file_msg").show();
            }
        }
    });

    var postuler = $('.btn_postuler');
    
    postuler.on('click touch', function(){
        var poste_title = $(this).parent().parent().parent().find("h3 span").html();
        var inputPostTitle = $('#formCandidat #poste');
    
        inputPostTitle.val(poste_title);
    
        $('html, body').animate({
            scrollTop: $("body.satellite_recrutement").offset().top
        }, 500);
    });
});

function formCandidatSubmit() {

    error = 0;

    array_fields.forEach(function(field){
        if($('#'+field).val()=='') {
            $('#'+field).addClass('inputErr');
            error++;
        } else {
            if(field=='candidatEmail') {
                var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                var mail_value = $('#'+field).val();
                if(mail_value.match(mailformat))
                {
                    $('#'+field).removeClass('inputErr');
                } else {
                    $('#'+field).addClass('inputErr');
                    error++;
                }
            } else if(field=='candidatTel') {
                if( $("#candidatTel").intlTelInput("isValidNumber") == false ){
                    $('#'+field).addClass('inputErr');
                    error++;
                } else {
                    $('#'+field).removeClass('inputErr');
                }
            } else {
                $('#'+field).removeClass('inputErr');
            }
        }
    });

    if ($("#cv").val() === "") {
        error++;
        $(".bloc_cv .upload").addClass("inputErr");
    } else {
        $(".bloc_cv .upload").removeClass("inputErr");
    }

    if ($("#motivation_letter").val() === "") {
        error++;
        $(".bloc_motivation .upload").addClass("inputErr");
    } else {
        $(".bloc_motivation .upload").removeClass("inputErr");
    }

    if (error === 0) {
        var $form = $("#formCandidat");
        var formdata = window.FormData ? new FormData($form[0]) : null;

        var data = formdata !== null ? formdata : $form.serialize();
        var url =
            path_relative_root +
            create_link("satellite_envoyer_candidature") +
            "?page=" +
            $(location).attr("href");

        $.ajax({
            type: "post",
            url: url,
            contentType: false,
            processData: false,
            data: data,
            success: function(response) {
                if (response === "1") {
                    $("#formCandidat").hide();
                    $("#msg_success").show("slow");
                    $("#loader_1")
                        .parent()
                        .removeClass("loading");
                    $("#loader_1").removeClass("loading");
                } else {
                    $("#msg_suspens").show();
                }
            },
        });
    } else {
        setTimeout(function() {
            $("#loader_1")
                .parent()
                .removeClass("loading");
            $("#loader_1").removeClass("loading");
        }, 500);
    }
}